import { Refusals } from "../../../utils/refusalMessageKey";

// RSSUKO001 is the dashboard's own field check or an invalid phone number, RSUSKO007 UMD's field check.
export const BUSINESS_CARD_REGISTER_REFUSALS: Refusals = {
  "429": "customRegistration.page.toast.tooManyAttempts",
  ISSYKO002: "businessCard.register.unavailable",
  RSUSKO034: "businessCard.register.unavailable",
  RSSUKO001: "businessCard.register.checkDetails",
  RSUSKO007: "businessCard.register.checkDetails",
  RSUSKO029: "customRegistration.page.toast.accountRefused",
  RSUSKO031: "customRegistration.page.toast.emailDomainNotAllowed",
};
